import { useMutation } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import { removeProfilePhoto } from "../../services/portalAluno/profile/profileService";
import { updateAuthPhoto } from "../../store/ducks/auth/actions";
import type { ApplicationState } from "../../store";

const useRemoveProfilePhoto = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state: ApplicationState) => state.auth.data);

  return useMutation({
    mutationFn: () => {
      if (!auth?.idUsuario) throw new Error("Sessão de usuário inválida.");
      return removeProfilePhoto();
    },
    onSuccess: () => dispatch(updateAuthPhoto()),
  });
};

export default useRemoveProfilePhoto;
